import React from 'react';
import './styles/ClientReviews.css';
import ELBeckett from './images/review/E.L. Beckett.jpg'
import KarlSjoberg from './images/review/Karl Sjoberg.avif'
import AlexLee from './images/review/Alex Lee.jpeg'
import AngelaGarvey from './images/review/Angela Garvey.webp'
import TerryBriscoe from './images/review/Terry Briscoe.jpeg'
import SterlingNixon from './images/review/Sterling Nixon.webp'
import vicki from './images/review/Vicki Jo Eva.jpeg'
import NateBarham from './images/review/Nate Bahram.png'
import Inspirational from './images/review/inspirrational book writes.jpeg'
import ALilLady from './images/review/A Lill Lady.jpg'
import TammieBullard from './images/review/Tammie Bullard(Author.jpg'
import  JamesLeitch from './images/review/James LIETCH.jpg'

const Testimonials = () => {
  const testimonials = [
    {
      name: "E.L. Beckett",
      text: "He is always such a pleasure to work with! I have been working with him for quite some time, and he continually exceeds expectations!.",
      image:ELBeckett ,
      stars: 5,
  },
  {
      name: "Karl Sjoberg",
      text: "Always on target and easy to work with.Don't hesitate to use him. The absolute best!",
      image: KarlSjoberg,
      stars: 5,
  },
  {
      name: "Alex Lee",
      text: "So pleased that Nauman was recommended to me . I enjoyed everything about our collaboration and found him to be a real professional in every aspect of post production . I am looking forward to our next project 😊",
      image: AlexLee,
      stars: 5,
  },
  {
    name: "Angela Garvey",
    text: "Working with Nauman was such a great experience! I would highly *highly* recommend him for any ACX audiobook project. He has a strong attention to detail and the quality was outstanding. Such a pleasure to work with. Thank you!",
    image:AngelaGarvey ,
    stars: 5,
},
{
    name: "Terry Briscoe",
    text: "Muhammad is a top notch audio editor. I have worked with him on a number of audiobook projects and will continue to do so in the future. He is a real pro, is fair with his pricing and his communication is excellent. I would highly recommend.",
    image: TerryBriscoe,
    stars: 5,
},
{
    name: "Sterling Nixon",
    text: "Always awesome working with him and he does a great job.",
    image: SterlingNixon,
    stars: 5,
},
{
    name: "Vicki-Jo Eva",
    text: "Fantastic work and great communication throughout! Has been so easy and straightforward to work with Muhmmad. I Will definitely be back to order again!",
    image:vicki ,
    stars: 5,
},
{
    name: "Nate Barham",
    text: "Nauman is great as always, and very flexible in working with my author’s timelines. Highly recommended to edit your next audiobook!",
    image: NateBarham,
    stars: 5,
},
{
    name: "Inspirational Book Writers",
    text: "We are publishing company from australia. on monthly basis we refer our many audiobook clients to him. What a fantastic, high quality service. Nauman's attention to detail is econd to none and we are so happy with every aspect of his work.😊",
    image: Inspirational,
    stars: 5,
},
{
  name: "A Lil Lady",
  text: "I loved working with Nauman. Not only did the sound quality exceed my expectations, but his customer service did as well. My Audible audiobook sounds very professional and all suggested edits were taken into serious consideration. Full disclaimer, since my book was about 3 hours, it took a little longer than 3 days. However, I expected that because I had a lot of ideas and feedback that slowed the process. I truly appreciated his hard work and love the finished product.",
  image:ALilLady ,
  stars: 5,
},
{
  name: "Tammie Bullard",
  text: "What a fantastic, high quality service. Nauman's attention to detail is econd to none and I am so happy with every aspect of his work.",
  image: TammieBullard,
  stars: 5,
},
{
  name: "James Leitch",
  text: "Solid work! It was exactly what I was hoping for from an editor! I am looking forward to working more with Nauman soon, as I will be relying on him for editing services for my audiobook narration moving forward.",
  image: JamesLeitch,
  stars: 5,
}
  ];


  return ( 
  <div className="testimonials-section">
    <div className="testimonials-header">
       
        <h3>What Clients Think And Say <br /> About Our Services</h3>
    </div>
    <div className="testimonials-cards">
        {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
                <div className="testimonial-header">
                    <img src={testimonial.image} alt={testimonial.name} />
                    <div className="testimonial-info">
                        <h4>{testimonial.name}</h4>
                        <div className="stars">
                            {"⭐".repeat(testimonial.stars)}
                        </div>
                    </div>
                </div>
                <p className="testimonial-text">"{testimonial.text}"</p>
            </div>
        ))}
    </div>
</div>
  );
};

export default Testimonials;
